import { render, staticRenderFns } from "./CommentReferenceWidget.vue?vue&type=template&id=6a445d62&scoped=true"
import script from "./CommentReferenceWidget.vue?vue&type=script&lang=js"
export * from "./CommentReferenceWidget.vue?vue&type=script&lang=js"
import style0 from "./CommentReferenceWidget.vue?vue&type=style&index=0&id=6a445d62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a445d62",
  null
  
)

export default component.exports